import { useState } from 'react';
import { useSessionAppointmentId } from '@hooks/useSessionAppointmentId';
import { parseAsString, useQueryState } from '@lib/queryState';

export const TabEnum = {
  SECURITY: 'Security',
  ASSESS: 'Assess',
  DOCUMENTS: 'Documents',
  LETTERS: 'Letters',
  CLINICAL: 'Clinical',
  OUTCOME: 'Outcome', // V1
  ACTIONS: 'Actions', // V2
  GP_RECORD: 'GP Record',
  ERS_REFERRAL: 'ERS Referral',
  REQUESTS: 'Requests'
};

function useAppointmentActiveTab(apptId: number) {
  return useQueryState(`activeTab_${apptId}`, parseAsString);
}

const useSessionTabs = () => {
  const [tabs, setTabs] = useState([
    TabEnum.GP_RECORD,
    TabEnum.SECURITY,
    TabEnum.CLINICAL,
    TabEnum.ERS_REFERRAL,
    TabEnum.REQUESTS,
    TabEnum.ACTIONS,
    TabEnum.OUTCOME,
    TabEnum.LETTERS
  ]);
  const apptId = useSessionAppointmentId(true);

  const [suppliedActiveTab, setActiveTab] = useAppointmentActiveTab(apptId);
  const activeTab = suppliedActiveTab && tabs?.includes(suppliedActiveTab) ? suppliedActiveTab : tabs?.[0];

  return { tabs, setTabs, activeTab, setActiveTab };
};

export { useSessionTabs };
